exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1GvaaYVExelYtcmVS76hiW{position:absolute;top:0;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;height:100%;width:100%}html[dir] ._1GvaaYVExelYtcmVS76hiW{text-align:center}html[dir=ltr] ._1GvaaYVExelYtcmVS76hiW{left:0}html[dir=rtl] ._1GvaaYVExelYtcmVS76hiW{right:0}._3aoFKl08hBcc2qVb_dDK_D{width:400px;font-size:17px;font-weight:300}", ""]);

// exports
exports.locals = {
	"messageContainer": "_1GvaaYVExelYtcmVS76hiW",
	"messageText": "_3aoFKl08hBcc2qVb_dDK_D"
};